import { useState } from "react"

import Style from "./style"

import PageTitle from "widget/PageTitle"
import ImageModal from "widget/ImageModal"

import useGetAdDetail from "entity/column/useGetAdDetail"
import timestampCalculator from "shared/lib/timestampCalculator"
import DefaultButton from "shared/ui/DefaultButton"

const AdDetail = () => {
    const [expandImgSrc, setExpandImgSrc] = useState(null)

    const [adData] = useGetAdDetail()

    return (
        <>
            {expandImgSrc && <ImageModal src={expandImgSrc} closeEvent={() => setExpandImgSrc(null)} />}

            <Style.Wrapper>
                <PageTitle>소식 하이라이트</PageTitle>
                <p>작성일 : {timestampCalculator(adData?.data?.created_at)}</p>
                <Style.ImgList>
                    {adData?.data?.img_list?.map(elem =>
                        <img src={elem} onClick={() => setExpandImgSrc(elem)} />
                    )}
                </Style.ImgList>
                {adData?.data?.url && <DefaultButton clickEvent={() => window.location.href = adData?.data?.url}>상세 내용 확인하기</DefaultButton>}
            </Style.Wrapper>
        </>
    )
}

export default AdDetail